'use strict';

require('../app');
